/**
 * Non Breaking Space: A space character that can be used in HTML strings.
 */
export const NBSP = '\u00A0'
/**
 * Mail To Line Break: A line break character that can be used in `mailto:?body=` strings.
 */
export const MTLB = '\r\n'
